<template>
  <div>
    create entreprise
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>